/*
  Estrutura o conteúdo das páginas legais.

  O texto das políticas foi colado como um bloco único, com quebras de linha
  (<br>) em vez de parágrafos, títulos e listas. Isso faz com que frases
  apareçam "abaixo da linha onde deviam estar" e sem espaçamento.

  Este script converte, apenas no browser e sem alterar o conteúdo guardado:
    "1. PROCESSAMENTO DA ENCOMENDA"  ->  <h2>
    "- Condições meteorológicas"     ->  <li> dentro de <ul>
    restantes linhas                 ->  <p>

  Se o conteúdo já estiver bem formatado (já tem <h2>/<h3>/<ul>/<ol>),
  o script não mexe em nada.
*/
(function () {
  'use strict';

  var SELECTOR = '.shopify-policy__body .rte, .legal-page__body .rte';
  var HEADING_RE = /^\d+\s*[.)\-–]\s*(.+)$/;
  var BULLET_RE = /^[-–—•*]\s+(.+)$/;

  function cleanLine(html) {
    return html
      .replace(/&nbsp;/gi, ' ')
      .replace(/^(\s|<br\s*\/?>)+|(\s|<br\s*\/?>)+$/gi, '')
      .trim();
  }

  function textOf(html) {
    var el = document.createElement('div');
    el.innerHTML = html;
    return (el.textContent || '').trim();
  }

  function isHeadingLine(html) {
    var text = textOf(html);
    var match = text.match(HEADING_RE);
    if (!match) return false;

    // Só é título se estiver em maiúsculas (ex.: "2. ENVIO PARA PORTUGAL").
    // Os parêntesis são ignorados: "3. ENVIO PARA ILHAS (Açores e Madeira)".
    var letters = match[1].replace(/\([^)]*\)/g, ' ').replace(/[^\p{L}]/gu, '');
    return letters.length > 2 && letters === letters.toLocaleUpperCase('pt-PT');
  }

  function bulletContent(html) {
    var text = textOf(html);
    if (!BULLET_RE.test(text)) return null;
    // Remove o marcador do início mantendo o HTML restante (links, negritos...).
    return html.replace(/^\s*[-–—•*]\s+/, '');
  }

  function buildFragment(lines) {
    var fragment = document.createDocumentFragment();
    var list = null;
    var created = 0;

    lines.forEach(function (line) {
      if (!textOf(line)) return;

      var bullet = bulletContent(line);

      if (bullet !== null) {
        if (!list) {
          list = document.createElement('ul');
          fragment.appendChild(list);
        }
        var item = document.createElement('li');
        item.innerHTML = bullet;
        list.appendChild(item);
        created += 1;
        return;
      }

      list = null;

      var node = document.createElement(isHeadingLine(line) ? 'h2' : 'p');
      if (node.tagName === 'H2') node.className = 'legal-heading';
      node.innerHTML = line;
      fragment.appendChild(node);
      created += 1;
    });

    return created ? fragment : null;
  }

  function enhanceBlock(block, isRoot) {
    var lines = block.innerHTML.split(/<br\s*\/?>/gi).map(cleanLine);
    if (lines.length < 2) return;

    var fragment = buildFragment(lines);
    if (!fragment) return;

    if (isRoot) {
      block.innerHTML = '';
      block.appendChild(fragment);
    } else {
      block.parentNode.replaceChild(fragment, block);
    }
  }

  function enhance(root) {
    if (!root || root.dataset.legalEnhanced) return;
    root.dataset.legalEnhanced = 'true';

    // Conteúdo já estruturado pelo editor: não tocar.
    if (root.querySelector('h2, h3, h4, ul, ol')) return;
    if (!root.querySelector('br')) return;

    var paragraphs = Array.prototype.slice.call(root.querySelectorAll('p'));

    if (paragraphs.length) {
      paragraphs.forEach(function (paragraph) {
        if (paragraph.querySelector('br')) enhanceBlock(paragraph, false);
      });
    } else {
      enhanceBlock(root, true);
    }
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Pré-visualização no editor de temas (secções recarregadas via AJAX).
  document.addEventListener('shopify:section:load', init);
})();
